var React = require('react');

function TableCrossMark (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.5"},[React.createElement("path",{"d":"M5 5L19 19","stroke":"#A3AFC2","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M19 5L5 19","stroke":"#A3AFC2","strokeWidth":"2","key":1})]));
}

TableCrossMark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TableCrossMark;

TableCrossMark.default = TableCrossMark;
